export const WRITING_ASSISTSANT_SEO_TITLE = 'Free Writing Assistant | CitationMachine'
export const WRITING_ASSISTSANT_SEO_DESCRIPTION =
  'Receive free grammar tips along with tools to condense, expand, or rephrase your text.'
